// extracted by css-extract-rspack-plugin
export default {"cls1":"RelatedWorksCard-cls1_wj2","cls2":"RelatedWorksCard-cls2_ahQ RelatedWorksCard-cls1_wj2"};